import type { AxiosInstance } from 'axios';
import type { OsobyEditorSeznamDto } from '../generated';

export const editorsOvmQuery = async (
	axiosInstance: AxiosInstance,
	ico?: number
): Promise<OsobyEditorSeznamDto> => {
	const { data } = await axiosInstance.get(
		`api/v1/editori?ico=${ico}&kodUdaje=PravniForma`
	);
	return data;
};
